export const STORY_MEDIA_SOURCE = {
  ACTIV8: 'ACTIV8',
  FAVORITE: 'FAVORITE',
  UPLOADED: 'UPLOADED',
};

export const STORY_ALTERNATIVE_SOURCE = {
  ACTIV8_CONTENT: 'ACTIV8_CONTENT',
  STUDIO_FAVORITE: 'STUDIO_FAVORITE',
  UPLOADED: 'UPLOADED',
  MESSAGE: 'MESSAGE',
  SEARCH: 'SEARCH',
};
